module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center1"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("Praise for "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("An Unsuitable Job for a Woman")])])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('p', {
    staticClass: "blockquote"
  }, [_vm._v("“The reigning mistress of murder… [her] vivid, compelling whodunits over almost a quarter of a century have made James one of the world’s leading crime writers and a worthy successor to Sir Arthur Conan Doyle and Agatha Christie.”")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_vm._v("—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Time")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("“She writes like an angel. Every character is clearly drawn. Her atmosphere is unerringly, chillingly convincing. And she manages all this without for a moment slowing down the drive and tension of an exciting mystery.”")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_vm._v("—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("London Times")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("“If we’re lucky, there will always be an England, and there will always be a P. D. James.”")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_vm._v("—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Cosmopolitan")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("“Ms. James is simply a wonderful writer.”")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("—The New York Times Book Review")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("“The nonpareil of the literary mystery… she transcends simple literary classification.”")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_vm._v("—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Chicago Sun-Times")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("“Written in the 1970s, this thriller has lost none of its punch.”")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_vm._v("—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Vogue")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("Praise for P. D. James")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("“One reads a P. D. James novel in something like the spirit that one reads a novel by Zola, Balzac, Thackeray, or Dickens.”")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_vm._v("—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("The Christian Science Monitor")])])]), _c('p', {
    staticClass: "blockquote"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("“The ability to haunt has earned P. D. James the title ‘queen of crime.’ Long may she reign.”")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "att"
  }, [_vm._v("—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Chicago Sun-Times")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("“P. D. James… writes the most lethal, erudite, people-complex novels of murder and detection since Michael Innes first began and Dorothy Sayers left us.”")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_vm._v("—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Vogue")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("“James delivers the pace and tensions of a mystery yarn better than any other living writer.”")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_vm._v("—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("People")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("“The best practitioner of the mystery novel writing today.”")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_vm._v("—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("The Boston Globe")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0dbecc18","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/a_fm01.vue
// module id = 69
// module chunks = 0